module.exports = __webpack_public_path__ + "static/media/[Annual_Oration]2010.1a7ac267.md";